module.exports = __webpack_public_path__ + "static/media/Akoya.5c213fe1.png";